import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

import { Globals } from '../providers/globals';
import { HttpHelper } from '../helpers/httpHelper';
import { Storage } from '@ionic/storage';

import { BaseProvider } from './base-provider';

@Injectable()
export class ConsumerBusinessHandlerProvider extends BaseProvider {
	url: any;
	token: any;
	business: any;

	debitList: any = [];
	creditsList: any = [];

	constructor(  		
		public http: Http,
		public globals: Globals,
	  	public storage: Storage,
	  	public httpHelper: HttpHelper
		) {    
		super();
	}

	refreshBusiness(){
		//Reload businesses
		this.getBusinessMoney({page:1,size:20});
		//Reload business detail
		this.getBusinessMoneyById({id:this.business.Id});
		//Reload credits
		this.getUserPurchases({
			businessId:this.business.Id, 
			page:1,
			size:20
		});
	}

	getBusinesses(params){	
		this.url = this.globals.dataUrl + 'consumerBusiness/whiskey/' + this.globals.whiskeyId +
										  '/latNE/' + params.latNE +
										  '/latSW/' + params.latSW +
										  '/longNE/' + params.lngNE +
										  '/longSW/' + params.lngSW +
										  '/page/' + params.page +
										  '/size/' + params.size +
										  '?term=' + params.term +
										  '&categories=' + params.categories;
										  
		this.storage.get('loginData').then((loginData) => {
		  this.token = loginData.access_token

		  this.http.get(
		    this.url,
		    this.httpHelper.configOptionsWithToken(loginData.access_token)
		  )
		  .map(res => res.json())
		  .subscribe(res => {
		      if(params.cb) params.cb(res.Data);
		  });   
		})
	}  

	getBusinessMoney(params){	
		this.url = this.globals.dataUrl + 'consumerBusiness/whiskey/' + this.globals.whiskeyId +
										  '/money/page/' + params.page +
										  
										  '/size/' + params.size +
										  '?term=' + params.term +
										  '&business=' + params.id;
										  
		this.http.get(
			this.url,
			this.httpHelper.configOptionsWithToken(this.globals.loginData.access_token)
		)
		.map(res => res.json())
		.subscribe(res => {
			if(params.page==1){
				this.list = res.Data;
			}else{
				this.pushItems(res.Data);
			}
		
			if(params.cb) params.cb(res.Data);
		});   
	}  	

	getBusinessMoneyById(params){	
		this.url = this.globals.dataUrl + 'consumerBusiness/whiskey/' + this.globals.whiskeyId +
										  '/money/page/1/size/1' +
										  '?business=' + params.id;
										  
		this.http.get(
			this.url,
			this.httpHelper.configOptionsWithToken(this.globals.loginData.access_token)
		)
		.map(res => res.json())
		.subscribe(res => {
			try{
				this.business = res.Data[0];
			}catch(e){}
			
			if(params.cb) params.cb(res.Data);
		});  
	}  		

	getUserDebits(params){	
		this.url = this.globals.dataUrl + 'consumerMoney/debit' +
										  '/business/' + params.businessId +
										  '/page/' + params.page +
										  '/size/' + params.size;

		this.http.get(
			this.url,
			this.httpHelper.configOptionsWithToken(this.globals.loginData.access_token)
		)
		.map(res => res.json())
		.subscribe(res => {
			this.debitList = res.Data;
			if(params.cb) params.cb(res.Data);
		});  
	}  	

	getUserPurchases(params){	
		this.url = this.globals.dataUrl + 'consumerMoney/purchase' +
										  '/business/' + params.businessId +
										  '/page/' + params.page +
										  '/size/' + params.size;
										  										  
		this.http.get(
			this.url,
			this.httpHelper.configOptionsWithToken(this.globals.loginData.access_token)
		)
		.map(res => res.json())
		.subscribe(res => {
			this.creditsList = res.Data;
			if(params.cb) params.cb(res.Data);
		});   
	}  		

	getBusinessById(params){	
		this.url = this.globals.dataUrl + 'consumerBusiness/whiskey/' + this.globals.whiskeyId + '/' + params.id;
										  
		this.storage.get('loginData').then((loginData) => {
		  this.token = loginData.access_token

		  this.http.get(
		    this.url,
		    this.httpHelper.configOptionsWithToken(loginData.access_token)
		  )
		  .map(res => res.json())
		  .subscribe(res => {
		      if(params.cb) params.cb(res.Data);
		  });   
		})
	}  	

	getBusinessByIdAndUser(params){	
		this.url = this.globals.dataUrl + 'consumerBusiness/whiskey/' + this.globals.whiskeyId + '/' + params.id + "/user";
										  
		this.storage.get('loginData').then((loginData) => {
		  this.token = loginData.access_token

		  this.http.get(
		    this.url,
		    this.httpHelper.configOptionsWithToken(loginData.access_token)
		  )
		  .map(res => res.json())
		  .subscribe(res => {
		      if(params.cb) params.cb(res.Data);
		  });   
		})
	}  	

	getPinnedBusinesses(cb){	
		this.url = this.globals.dataUrl + 'consumerBusiness/whiskey/' + this.globals.whiskeyId + '/pinned'

		this.storage.get('loginData').then((loginData) => {
		  this.token = loginData.access_token

		  this.http.get(
		    this.url,
		    this.httpHelper.configOptionsWithToken(loginData.access_token)
		  )
		  .map(res => res.json())
		  .subscribe(res => {
		      if(cb) cb(res.Data);
		  });   
		})
	}  	

	pinBusiness(params, cb){
		this.url = this.globals.dataUrl + 'consumerBusiness' + 
											'/business/' + params.businessId + 
											'/pin/' + params.pinned;

		this.http
		.post(
		  this.url, 
		  null, 
		  this.httpHelper.configOptionsWithToken(this.token)
		)
		.map(res => res.json())
		.subscribe(response => {
		    if(typeof cb == "function") cb(response.Data);
		});             
	}	
}




// WEBPACK FOOTER //
// ./src/providers/consumer-business-handler.ts